import React from 'react';
import { motion } from 'framer-motion';
import { useModal } from '../services/ModalService';
import '../styles/pages/FundAdministration.css';

const FundAdministration = () => {
  const { openContactModal } = useModal();

  return (
    <div className="fund-administration">
      {/* Hero Section */}
      <section className="fund-hero">
        <div className="fund-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="fund-hero-content"
          >
            <div className="hero-badge">
              🏦 Fund Solutions
            </div>
            
            <h1 className="hero-title"
            dangerouslySetInnerHTML={{ __html: "Professional <span class=\"gradient-text\">Fund Administration</span><br />Services" }}
            />
            
            <p className="hero-subtitle">
              Comprehensive fund administration services to support your investment management operations with accuracy, compliance, and efficiency.
            </p>
            
            <div className="hero-buttons">
              <button 
                className="btn-primary"
                onClick={() => openContactModal(
                  'Fund Administration Services',
                  'Fund Administration Page - Get Started Today'
                )}
              >
                Get Started Today
              </button>
              <button 
                className="btn-secondary"
                onClick={() => openContactModal(
                  'Fund Administration Information',
                  'Fund Administration Page - Learn More'
                )}
              >
                Learn More
              </button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Services Section */}
      <section className="fund-section">
        <div className="fund-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h2 className="fund-section-title gradient-text">Fund Administration Services</h2>
            <p className="fund-section-subtitle">
              End-to-end fund administration solutions tailored to your investment management needs
            </p>
            
            <div className="fund-services-grid">
              
              <div className="fund-glass-card">
                <h3>Net Asset Value Calculation</h3>
                <p>Accurate and timely NAV calculations with comprehensive portfolio valuation services.</p>
                <ul>
                  <li>✓ Daily NAV Calculations</li>
                  <li>✓ Portfolio Valuation</li>
                  <li>✓ Price Verification</li>
                  <li>✓ Performance Reporting</li>
                </ul>
              </div>
              
              <div className="fund-glass-card">
                <h3>Investor Services</h3>
                <p>Comprehensive investor relations and shareholder services to support your fund operations.</p>
                <ul>
                  <li>✓ Investor Onboarding</li>
                  <li>✓ Capital Call Processing</li>
                  <li>✓ Distribution Management</li>
                  <li>✓ Investor Reporting</li>
                </ul>
              </div>
              
              <div className="fund-glass-card">
                <h3>Financial Reporting</h3>
                <p>Professional financial reporting and regulatory compliance for investment funds.</p>
                <ul>
                  <li>✓ Financial Statements</li>
                  <li>✓ Regulatory Filings</li>
                  <li>✓ Tax Reporting</li>
                  <li>✓ Audit Support</li>
                </ul>
              </div>
              
              <div className="fund-glass-card">
                <h3>Operations Support</h3>
                <p>Operational support services to streamline your fund management processes.</p>
                <ul>
                  <li>✓ Trade Settlement</li>
                  <li>✓ Cash Management</li>
                  <li>✓ Corporate Actions</li>
                  <li>✓ Risk Monitoring</li>
                </ul>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="fund-section">
        <div className="fund-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <h2 className="fund-section-title gradient-text">Why Choose Our Fund Administration</h2>
            <p className="fund-section-subtitle">
              Professional expertise and proven results for investment fund administration
            </p>
            
            <div className="fund-benefits-grid">
              
              <div className="fund-benefit-card">
                <div className="fund-benefit-icon">⚖️</div>
                <h4 className="fund-benefit-title">Regulatory Expertise</h4>
                <p className="fund-benefit-description">Deep knowledge of investment fund regulations and compliance</p>
              </div>
              
              <div className="fund-benefit-card">
                <div className="fund-benefit-icon">📊</div>
                <h4 className="fund-benefit-title">Accurate Reporting</h4>
                <p className="fund-benefit-description">Precise financial reporting and performance analytics</p>
              </div>
              
              <div className="fund-benefit-card">
                <div className="fund-benefit-icon">🔒</div>
                <h4 className="fund-benefit-title">Data Security</h4>
                <p className="fund-benefit-description">Bank-grade security for sensitive fund information</p>
              </div>
              
              <div className="fund-benefit-card">
                <div className="fund-benefit-icon">🚀</div>
                <h4 className="fund-benefit-title">Scalable Solutions</h4>
                <p className="fund-benefit-description">Services that grow with your fund management business</p>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="fund-section">
        <div className="fund-container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="fund-cta-card">
              <h3 className="fund-cta-title">
                Ready to Optimize Your Fund Operations?
              </h3>
              <p className="fund-cta-subtitle">
                Contact us today to learn how our fund administration services can enhance your investment management operations and ensure compliance.
              </p>
              <div className="fund-cta-buttons">
                <button 
                  className="btn-primary"
                  onClick={() => openContactModal(
                    'Fund Administration Setup',
                    'Fund Administration Page - Start Fund Administration'
                  )}
                >
                  Start Fund Administration
                </button>
                <button 
                  className="btn-secondary"
                  onClick={() => openContactModal(
                    'Fund Administration Consultation',
                    'Fund Administration Page - Schedule Consultation'
                  )}
                >
                  Schedule Consultation
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default FundAdministration;